import React, { Component } from 'react';
import firebase from '../firebase';
import Message from '../Message/Message';
import './ChatWindow.css';

class ChatWindow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentMessage: '',
      userName: this.props.username,
      messageList: {},
      currentRoom: '',
    };
  }

  componentDidMount() {
    const { room } = this.props;
    this.setState({ currentRoom: room });
    this.updateMessages();
  }

  componentDidUpdate(prevProps) {
    const { room } = this.props;
    if (room !== prevProps.room) {
      this.setState({
        currentRoom: room,
      });
      this.updateMessages();
    }
  }

  componentWillUnmount() {
    const { room } = this.props;
    firebase
      .database()
      .ref(`/ChatRooms/${room}/Messages`)
      .off();
  }

  updateMessages = () => {
    const { room } = this.props;
    const dbRef = firebase.database().ref(`/ChatRooms/${room}/Messages`);
    dbRef.limitToLast(15).on('value', snapshot => {
      this.setState({
        messageList: snapshot.val(),
      });
    });
  };

  handleChange = e => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  handleSubmit = e => {
    e.preventDefault();

    const { currentMessage, userName, currentRoom } = this.state;

    if (/\S/.test(currentMessage)) {
      const currDate = new Date().getTime();

      const newMessage = {
        content: currentMessage,
        author: userName,
        date: currDate,
      };

      this.setState({
        currentMessage: '',
      });

      firebase
        .database()
        .ref(`/ChatRooms/${currentRoom}/Messages`)
        .push(newMessage);
    } else {
      this.setState({
        currentMessage: '',
      });
    }
  };

  render() {
    const { messageList, currentMessage } = this.state;
    const { room } = this.props;
    return (
      <div className="chat-window">
        <div className="chat-room-indicator-mobile">
          <p>{room}</p>
        </div>
        <div className="message-window">
          {messageList !== {}
            ? Object.entries(messageList).map(element => (
                <Message
                  date={element[1].date}
                  name={element[1].author}
                  message={element[1].content}
                  key={element[0]}
                />
              ))
            : null}
        </div>

        <form
          action=""
          className="message-input-form"
          onSubmit={this.handleSubmit}
        >
          <input
            className="message-input"
            type="text"
            placeholder="Your Message"
            id="currentMessage"
            onChange={this.handleChange}
            value={currentMessage}
            required
            autoComplete="off"
          />
          <input className="message-submit" type="submit" value="Send" />
        </form>
      </div>
    );
  }
}

export default ChatWindow;
